var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C15.3315 4.76838e-07 15.6495 0.131697 15.8839 0.366118C15.9486 0.430797 16.0272 0.508763 16.1188 0.599475C17.2541 1.72446 20.3677 4.80988 23.2918 8.82685C26.4201 13.1242 29.5 18.7105 29.5 24.25C29.5 29.6262 27.9015 33.6073 25.1879 36.2408C22.4847 38.8643 18.8292 40 15 40C11.1708 40 7.51534 38.8643 4.81207 36.2408C2.09851 33.6073 0.5 29.6262 0.5 24.25C0.5 18.7148 3.51283 13.1932 6.61343 8.92193C9.50341 4.94083 12.6094 1.86087 13.8479 0.632722C13.9505 0.530959 14.0403 0.44191 14.1161 0.366115C14.3505 0.131695 14.6685 -4.76836e-07 15 0Z",
    fill: "#9BCAEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.dfd5ba82c14bd3d69cba607c8efa0692.svg";
export { ForwardRef as ReactComponent };